import { MyPurchaseForm } from "src/app/shared/models/app-models";

export const isReadOnly = (form: MyPurchaseForm, loggedInUsername: string): boolean => {
    if (form.CE)
        return (form.documentStatusId != 2 && form.documentStatusId != 3 && form.documentStatusId != 6 && form.documentStatusId != 11)
    else
        return true
}